
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  Bot, 
  HelpCircle, 
  MessageSquare, 
  ShieldCheck, 
  Scale 
} from 'lucide-react';
import { 
  SidebarGroup, 
  SidebarGroupContent, 
  SidebarGroupLabel, 
  SidebarMenu, 
  SidebarMenuItem, 
  SidebarMenuButton 
} from '@/components/ui/sidebar';
import { cn } from '@/lib/utils';
import ROUTES from '@/routes-map';

const SupportGroup: React.FC = () => {
  const location = useLocation();

  const isActive = (path: string) => {
    return location.pathname === path || location.pathname.startsWith(path);
  };

  return (
    <SidebarGroup>
      <SidebarGroupLabel>Support</SidebarGroupLabel>
      <SidebarGroupContent>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton asChild className={cn(isActive(ROUTES.DOCTOR.AI_ASSISTANT) && "bg-accent text-accent-foreground")}>
              <Link to={ROUTES.DOCTOR.AI_ASSISTANT}>
                <Bot className="h-5 w-5" />
                <span>AI Assistant</span>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
          
          <SidebarMenuItem>
            <SidebarMenuButton asChild className={cn(isActive(ROUTES.DOCTOR.FAQ_SUPPORT) && "bg-accent text-accent-foreground")}>
              <Link to={ROUTES.DOCTOR.FAQ_SUPPORT}>
                <HelpCircle className="h-5 w-5" />
                <span>Help Center (FAQ)</span>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
          
          <SidebarMenuItem>
            <SidebarMenuButton asChild className={cn(isActive(ROUTES.DOCTOR.CONTACT_SUPPORT) && "bg-accent text-accent-foreground")}>
              <Link to={ROUTES.DOCTOR.CONTACT_SUPPORT}>
                <MessageSquare className="h-5 w-5" />
                <span>Contact Support</span>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
          
          <SidebarMenuItem>
            <SidebarMenuButton asChild className={cn(isActive(ROUTES.DOCTOR.PRIVACY_POLICY) && "bg-accent text-accent-foreground")}>
              <Link to={ROUTES.DOCTOR.PRIVACY_POLICY}>
                <ShieldCheck className="h-5 w-5" />
                <span>Privacy Policy</span>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
          
          <SidebarMenuItem>
            <SidebarMenuButton asChild className={cn(isActive(ROUTES.DOCTOR.LEGAL_TERMS) && "bg-accent text-accent-foreground")}>
              <Link to={ROUTES.DOCTOR.LEGAL_TERMS}>
                <Scale className="h-5 w-5" />
                <span>Legal Terms</span>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
};

export default SupportGroup;
